/* tslint:disable */

declare var Object: any;
export interface PadronNosisInterface {
  "apellido"?: string;
  "dni"?: string;
  "fechaactualizacion"?: Date;
  "idpadron"?: number;
  "nombre"?: string;
  "resultado"?: string;
}

export class PadronNosis implements PadronNosisInterface {
  "apellido": string;
  "dni": string;
  "fechaactualizacion": Date;
  "idpadron": number;
  "nombre": string;
  "resultado": string;
  constructor(data?: PadronNosisInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PadronNosis`.
   */
  public static getModelName() {
    return "PadronNosis";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PadronNosis for dynamic purposes.
  **/
  public static factory(data: PadronNosisInterface): PadronNosis{
    return new PadronNosis(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PadronNosis',
      plural: 'PadronNoses',
      path: 'PadronNoses',
      idName: 'idpadron',
      properties: {
        "apellido": {
          name: 'apellido',
          type: 'string'
        },
        "dni": {
          name: 'dni',
          type: 'string'
        },
        "fechaactualizacion": {
          name: 'fechaactualizacion',
          type: 'Date'
        },
        "idpadron": {
          name: 'idpadron',
          type: 'number'
        },
        "nombre": {
          name: 'nombre',
          type: 'string'
        },
        "resultado": {
          name: 'resultado',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/PadronNosis.ts